// 保全模块全局混入（修复版：支持 form / form2 / form3 自动切换）
export const preserveMixin = {
  computed: {
    // 🔥 核心：根据当前 type 自动获取【对应表单数据】
    currentForm() {
      switch (this.type) {
        case 1: return this.form;    // 车辆
        case 2: return this.form2;   // 房产
        case 3: return this.form3;   // 账户
        default: return this.form;
      }
    },
    // 🔥 核心：根据当前 type 自动获取【对应表单ref】
    currentFormRef() {
      switch (this.type) {
        case 1: return this.$refs.forms;    // 车辆ref
        case 2: return this.$refs.forms;   // 房产ref
        case 3: return this.$refs.forms;   // 账户ref
        default: return null;
      }
    },
    isPreserveRequired() {
      const form = this.currentForm; // ✅ 用自动匹配的表单
      if (!form || form.preservation_status === undefined) return false;
      return [8, 9].includes(Number(form.preservation_status));
    },
  },

  watch: {
    // 统一监听，自动匹配当前表单
    currentForm: {
      handler(newVal) {
        if (newVal) {
          this.clearPreserveValidate();
        }
      },
      deep: true,
    },
  },

  methods: {
    // 🔥 核心：清空当前表单的校验（精准匹配type）
    clearPreserveValidate() {
      const form = this.currentForm;
      const formInstance = this.currentFormRef;

      if (!form || !formInstance) return;

      // 非保全状态 → 清空时间 + 清除校验
      if (![8, 9].includes(Number(form.preservation_status))) {
        form.preservation_time = "";
        form.preservation_expired_time = "";

        // 清空当前表单的校验提示
        formInstance.clearValidate("preservation_time");
        formInstance.clearValidate("preservation_expired_time");
      }
    },

    // 保全时间验证（自动匹配当前表单）
    validatePreserveTime(rule, value, callback) {
      const form = this.currentForm;
      if (!form) return callback();
      
      const status = form.preservation_status;
      if ([8, 9].includes(Number(status)) && !value) {
        callback("请选择保全时间");
      } else {
        callback();
      }
    },

    // 保全到期时间验证（自动匹配当前表单）
    validatePreserveExpiredTime(rule, value, callback) {
      const form = this.currentForm;
      if (!form) return callback();
      
      const status = form.preservation_status;
      if ([8, 9].includes(Number(status)) && !value) {
        callback("请选择保全到期时间");
      } else {
        callback();
      }
    },
  },
};